export const TENENTS = [
  {
    name: "localhost",
    propertyId: "20240813184755",
    template: "one",
    templateTheme: "white-black"
  },
  {
    name: "surfaceinns.com",
    propertyId: "20210812185123",
    template: "one", templateTheme: "default"
  },
  {
    name: "europainnsuites.com",
    propertyId: "20180121204759",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "vanitywebsites.azurewebsites.net",
    propertyId: "20210521060044",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "hotelnovasfo.com",
    propertyId: "20190310080001",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "abvicf.com",
    propertyId: "20220207132232",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "economyinnsuite.com",
    propertyId: "20220124163022",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "thegreentreeinn.com",
    propertyId: "20220331174902",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "parkmanorcp.com",
    propertyId: "20220317174730",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "glendivelodge.com",
    propertyId: "20220523203643",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "copleyinnandsuites.com",
    propertyId: "20191224002122",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "surfaceinnworthington.com",
    propertyId: "20230313014704",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "homesteadinnmt.com",
    propertyId: "20231012040354",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "hotelinmodesto.com",
    propertyId: "20231220033723",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "lonetreeinn.com",
    propertyId: "20231111205410",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "dakotainnminot.com",
    propertyId: "20240229211316",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "quiltinnofkenmare.com",
    propertyId: "20240312170734",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "kennewicksuiteswa.com",
    propertyId: "20140914193052",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "hardinlodge.com",
    propertyId: "20240719181623",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "tribecahotelfidi.com",
    propertyId: "20240813184755",
    template: "one",
    templateTheme: "white-black"
  },
  {
    name: "brentwoodinnclinton.com",
    propertyId: "20241007175657",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "theprecioushotel.com",
    propertyId: "20241023012350",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "richlandinnmt.com",
    propertyId: "20250402163709",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "sundownerinnmt.com",
    propertyId: "20250402163017",
    template: "one",
    templateTheme: "default"
  },
  {
    name: "stewartlodgewa.com",
    propertyId: "20150630201005",
    template: "one",
    templateTheme: "default"
  },
];